export default {
  billingType: {
    type: 'string',
    required: true,
  },
  startDate: {
    type: 'date',
    required: true,
  },
  endDate: {
    type: 'date',
    required: true,
  },
  periodPolicy: {
    type: 'string',
    required: true,
  },
  scheduleItems: {
    type: 'array',
    maxSize: 100,
    required: true,
    forEach: {
      type: 'object',
      properties: {
        itemType: {
          type: 'string',
          required: false,
        },
        startDate: {
          type: 'string',
          required: {
            value: true,
            when: {
              '$.itemType': {
                ne: 'CHANGE_REQUEST',
              },
            },
          },
          maxDate: {
            value: '$.endDate',
            message: 'Please choose date before or at End date',
          },
        },
        endDate: {
          type: 'string',
          required: {
            value: true,
            when: {
              '$.itemType': {
                ne: 'CHANGE_REQUEST',
              },
            },
          },
          minDate: {
            value: '$.startDate',
            message: 'Please choose date after or at Start date',
          },
        },
        invoiceDate: {
          type: 'date',
          required: {
            value: true,
            when: {
              '$.itemType': {
                ne: 'CHANGE_REQUEST',
              },
            },
          },
        },
        amount: {
          type: 'string',
          required: true,
        },
      },
    },
  },
};
